import { Component, OnInit, Input, Output } from '@angular/core';

import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';


import * as _moment from 'moment';
import { defaultFormat as _rollupMoment, Moment } from 'moment';

import { NgZone } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CallsService } from 'src/app/services/calls/calls.service';

am4core.useTheme(am4themes_animated);


export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-count-call-box',
    templateUrl: './count-call-box.component.html',
    styleUrls: ['./count-call-box.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class CountCallBoxComponent implements OnInit {

    @Input() user;

    date = new FormControl(_moment());

    public labelDateSelected;
    public chartOutgoing;
    public chartIncoming;
    public loading = true;
    public report = {
        "calls" : {
            "incoming" : {
                "successful":0,
                "error": 0
            },
            "outgoing" : {
                "successful":0,
                "error": 0
            }
        },
        "tts" : {
            "successful":0,
            "error": 0
        }
    };


    public months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    private chart: am4charts.XYChart;

    constructor(
        private zone: NgZone,
        private callsService: CallsService
    ) { }

    ngOnInit() {
        this.labelDateSelected = this.months[this.date.value.month()] + "/" + this.date.value.year();
        this.getReport();
    }

    ngAfterViewInit() {
        
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.date.value;
        ctrlValue.year(normalizedYear.year());
        this.date.setValue(ctrlValue);
    }

    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value;
        ctrlValue.month(normalizedMonth.month());
        this.date.setValue(ctrlValue);
        this.labelDateSelected = this.months[normalizedMonth.month()] + "/" + normalizedMonth.year();
        this.getReport();
        datepicker.close();
    }

    createChartOutgoing() {
        this.zone.runOutsideAngular(() => {
            this.chartOutgoing = am4core.create("chartCallsOutgoingDiv", am4charts.PieChart);

            // Add data
            this.chartOutgoing.data = [
                {
                    "title": "Bem Sucedidas",
                    "value": this.report.calls.outgoing.successful
                },
                {
                    "title": "Mal Sucedidas",
                    "value": this.report.calls.outgoing.error
                }
            ];

            // Add and configure Series
            let pieSeries = this.chartOutgoing.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "title";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;

            pieSeries.colors.list = [
                am4core.color("#00a8a7"),
                am4core.color("red")
            ];


            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            // Desativando recursos do gráfico
            pieSeries.labels.template.disabled = true;
            pieSeries.ticks.template.disabled = true;
        });
    }

    createChartIncoming() {
        this.zone.runOutsideAngular(() => {
            this.chartIncoming = am4core.create("chartCallsIncomingDiv", am4charts.PieChart);

            // Add data
            this.chartIncoming.data = [
                {
                    "title": "Bem Sucedidas",
                    "value": this.report.calls.incoming.successful
                },
                {
                    "title": "Mal Sucedidas",
                    "value": this.report.calls.incoming.error
                }
            ];

            // Add and configure Series
            let pieSeries = this.chartIncoming.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "title";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;

            pieSeries.colors.list = [
                am4core.color("#00a8a7"),
                am4core.color("red")
            ];

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            // Desativando recursos do gráfico
            pieSeries.labels.template.disabled = true;
            pieSeries.ticks.template.disabled = true;
        });
    }

    createChartTts() {
        this.zone.runOutsideAngular(() => {
            this.chartIncoming = am4core.create("chartTtsDiv", am4charts.PieChart);

            // Add data
            this.chartIncoming.data = [
                {
                    "title": "Bem Sucedidas",
                    "value": this.report.tts.successful
                },
                {
                    "title": "Mal Sucedidas",
                    "value": this.report.tts.error
                }
            ];

            // Add and configure Series
            let pieSeries = this.chartIncoming.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "title";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;

            pieSeries.colors.list = [
                am4core.color("#00a8a7"),
                am4core.color("red")
            ];

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            // Desativando recursos do gráfico
            pieSeries.labels.template.disabled = true;
            pieSeries.ticks.template.disabled = true;
        });
    }

    ngOnDestroy() {
        this.zone.runOutsideAngular(() => {
            if (this.chartIncoming) {
                this.chartIncoming.dispose();
            }

            if (this.chartOutgoing) {
                this.chartOutgoing.dispose();
            }
        });
    }

    getReport() {
        this.loading = true;
        let month = this.date.value.month()+1;
        let year = this.date.value.year();
        this.callsService.report(
            this.user.payload,
            month,
            year
        ).subscribe((res)=>{
            this.report.calls = res.calls;
            this.report.tts = res.tts;
            this.loading = false;
            this.mountCharts();
        })
    }

    mountCharts(){
        this.createChartOutgoing();
        this.createChartIncoming();
        this.createChartTts();
    }

    getNow(){
        return new Date();
    }

}
